import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { IPasswordRules, PasswordRulesChecker } from './PasswordRulesChecker';
import { lastValueFrom } from 'rev-shared/rxjs/lastValueFrom';

@Injectable({
	providedIn: 'root'
})
export class PasswordValidationService {
	constructor(
		private http: HttpClient
	) {}

	public getPasswordRulesChecker(accountId: string): Promise<PasswordRulesChecker> {
		return lastValueFrom(this.http.get<IPasswordRules>(`/network/accounts/${accountId}/password-rules`))
			.then(rules => new PasswordRulesChecker(rules));
	}
}
